import _get from 'lodash/get'
import { z } from 'zod'

import { HOUSEHOLD_AT_CONSTANTS, HOUSEHOLD_STEPS } from '@flows/configs/householdAt/constants'
import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_HouseholdV1GetsafeAt } from '@flows/insurance/schemas'

const household_at_cohabitation_type = (params: StepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('cohabitation_type')]:
        BaseSchema_HouseholdV1GetsafeAt.shape.cohabitation_type,
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_householdAt:steps.cohabitation_type.title',
        },
      },
      {
        type: 'choice',
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('cohabitation_type'),
        options: HOUSEHOLD_AT_CONSTANTS.cohabitants_types.map((cohabitant) => {
          return {
            label: {
              type: 'translatableText',
              translationKey: `sharedFlows_householdAt:steps.cohabitation_type.options.${cohabitant}`,
            },
            value: cohabitant,
          }
        }),
      },
    ],
    subFlow: params.subFlow,
    nextStepConfig: {
      valuePath: params.helperFunctions.getParamPath('cohabitation_type'),
      valueToStepName: {
        single: HOUSEHOLD_STEPS.household_at_deductible_amount,
        family: HOUSEHOLD_STEPS.household_at_cohabitants,
        others: 'failure',
      },
    },
    onSubmit: {
      type: 'simpleHook',
      // insured_sum_amount field is hidden from the user and is calculated based on square_meters and furnishing_level
      callback: (flowValues) => {
        const getMultiplier = () => {
          const furnishing_level = BaseSchema_HouseholdV1GetsafeAt.shape.furnishing_level.parse(
            _get(flowValues, params.helperFunctions.getParamPath('furnishing_level'))
          )
          return HOUSEHOLD_AT_CONSTANTS.multiplier_values[furnishing_level]
        }

        const square_meters = z.coerce
          .number()
          .parse(_get(flowValues, params.helperFunctions.getParamPath('square_meters')))
        const multiplier = getMultiplier()
        const insured_sum_amount = square_meters * multiplier
        return {
          formValues: {
            [params.helperFunctions.getParamPath('insured_sum_amount')]: insured_sum_amount,
          },
        }
      },
    },
  }) as const satisfies AnyStepConfiguration

export default household_at_cohabitation_type
